import axios from '@api'

export default {
  getPassport () {
    return axios.get('api/auth/passport')
  }
}
